import React from "react";
import { View, StyleSheet } from "react-native";
import { layout } from "@/constants";
import Text from "./base/Text";

/**
 * Props for the SignificanceIndicator component
 */
interface SignificanceIndicatorProps {
  /** The significance level of the pattern */
  significance: "low" | "medium" | "high";
}

/**
 * Renders visual circles and text label for pattern significance
 * High: ●●● | Medium: ●●○ | Low: ●○○
 *
 * @param props - The component props
 * @returns Significance indicator with circles and label
 */
export default function SignificanceIndicator({
  significance
}: SignificanceIndicatorProps) {
  const getCircles = () => {
    switch (significance) {
      case "high":
        return "●●●";
      case "medium":
        return "●●○";
      case "low":
        return "●○○";
    }
  };

  const getLabel = () => {
    return `${significance.charAt(0).toUpperCase()}${significance.slice(1)} significance`;
  };

  return (
    <View style={styles.container}>
      <Text size="small" color="secondary" style={styles.circles}>
        {getCircles()}
      </Text>
      <Text size="small" color="secondary">
        {getLabel()}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    gap: layout.space.xs
  },
  circles: {
    letterSpacing: 0
  }
});
